// Robust API error parser
// Handles: string, Pydantic 422 detail arrays, network errors, timeouts, etc.
// Always returns a user-friendly French message.

export function parseApiError(err, fallback = "Une erreur est survenue. Merci de réessayer ou de nous appeler directement.") {
  // Network / timeout / CORS — no response at all
  if (!err?.response) {
    if (err?.code === 'ECONNABORTED') return "Le serveur met trop de temps à répondre. Merci de réessayer.";
    if (err?.message?.toLowerCase().includes('network')) return "Impossible de contacter le serveur. Vérifiez votre connexion Internet.";
    return fallback;
  }

  const status = err.response.status;
  const data = err.response.data;

  // Server sent a plain string
  if (typeof data === 'string' && data.trim()) return data;

  // Server sent an object with `detail`
  const detail = data?.detail;

  // Pydantic 422 — detail is a list of validation errors
  if (Array.isArray(detail)) {
    if (detail.length === 0) return fallback;
    const readable = detail
      .map((it) => {
        const field = Array.isArray(it?.loc) ? it.loc.filter((x) => x !== 'body').join(' → ') : '';
        const msg = it?.msg || '';
        // Translate common messages
        const fr =
          msg.includes('valid email') ? "adresse email invalide" :
          msg.includes('String should have at least') ? "champ trop court" :
          msg.includes('field required') || msg.includes('Field required') ? "champ obligatoire manquant" :
          msg.includes("Input should be 'ambulance'") ? "type de transport non sélectionné" :
          msg;
        return field ? `${prettyField(field)} : ${fr}` : fr;
      })
      .filter(Boolean);
    return readable.length > 0
      ? `Formulaire incomplet — ${readable.slice(0, 3).join(' ; ')}`
      : "Formulaire incomplet. Merci de vérifier vos informations.";
  }

  // Simple string detail
  if (typeof detail === 'string' && detail.trim()) return detail;

  // HTTP status-based fallbacks
  if (status === 413) return "Fichier trop volumineux.";
  if (status === 429) return "Trop de tentatives. Merci de patienter un instant.";
  if (status >= 500) return "Le serveur rencontre un problème temporaire. Merci de réessayer dans quelques instants.";

  return fallback;
}

const FIELD_LABELS = {
  nom: 'Nom',
  prenom: 'Prénom',
  telephone: 'Téléphone',
  email: 'Email',
  date_souhaitee: 'Date',
  heure_souhaitee: 'Heure',
  commune_depart: 'Commune de départ',
  destination: 'Destination',
  type_transport: 'Type de transport',
  prescription_medicale: 'Prescription médicale',
  rgpd: 'RGPD',
  message: 'Message',
  sujet: 'Sujet',
};

function prettyField(loc) {
  const key = loc.split(' → ').pop();
  return FIELD_LABELS[key] || key;
}
